module.exports = "<app-game></app-game>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/mobx-tic-tac.component.html
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/mobx-tic-tac.component.html
// module chunks = main